import React, { useRef } from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ComplaintList.css';
import { faTimes, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment/moment';

const ComplaintList = () => {

    const [data, setData] = useState([]);
    const [rotateAero, SetRotateAero] = useState(false);
    const [currentimage, setCurrentImage] = useState(false);

    const statusColor = useRef();

    console.warn(currentimage);


    useEffect(() => {
        getComplaintData();
    }, [])

    const getComplaintData = async () => {
        const res = await fetch("https://server.archanatusharpatil.in/complaintlist",{
        // const res = await fetch("http://localhost:5000/complaintlist", {
            headers: {
                authorization: JSON.parse(localStorage.getItem("token"))
            }
        });
        const result = await res.json();
        setData(result);
    }

    const getSearchData = async (key) => {
        if (key) {
            const res = await fetch(`https://server.archanatusharpatil.in/search/${key}`, {
                headers: {
                    authorization: JSON.parse(localStorage.getItem("token"))
                }
            });
            const result = await res.json();
            setData(result);
        }
        else {
            getComplaintData();
        }
    }

    const setOldComplaint = () => {
        SetRotateAero(!rotateAero);

        if (!rotateAero) {
            let today = new Date();
            let priorDate = moment(new Date(new Date().setDate(today.getDate() - 3))).format("YYYY-MM-DD  hh:mm:ss");
            const array = data?.filter((item) => {
                return item.date <= priorDate && item.status == "Pending";
            })
            setData(array);
        }
        else {
            getComplaintData();
        }
    }


    return (
        <>
            <div className="table-container conatainer-flued">
                <div className='table-header'>
                    <div className='old_compliant' onClick={() => setOldComplaint()}>
                        <div className='inner-box'>
                            <button>3 Days Old </button>
                            <FontAwesomeIcon icon={faAngleRight} color="#ffffff" className={rotateAero ? "right-aero-rotate" : "right-aero"} />
                        </div>
                    </div>
                    <div className='table-heading'>
                        <h1>ComplaintList</h1>
                    </div>
                    <div className='search_box'>
                        <input type="text" placeholder='Search...' onChange={(e) => getSearchData(e.target.value)} />
                        {/* <FontAwesomeIcon icon={faMagnifyingGlass} color="gray" size="2x" /> */}
                    </div>
                </div>
                <table>
                    <thead className='table-head'>
                        <tr>
                            <th>Id</th>
                            <th>Date</th>
                            <th>Name</th>
                            <th>Location</th>
                            <th>Category</th>
                            <th>Complaint</th>
                            <th>Status</th>
                            <th>Action</th>
                            <th>Image</th>
                            <th>Remark</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.length != "0" ?
                                data?.map((item) => {

                                    return (
                                        <>
                                            <tr>
                                                <td>{item.id}</td>
                                                <td>{moment(item.date).format("DD-MM-YYYY HH:mm:ss")}</td>
                                                <td>{item.name}<br />{item.mobile}</td>
                                                <td>{item.location}</td>
                                                <td>{item.category}</td>
                                                <td>{item.complaints}</td>
                                                {item.status == "Pending" ? <td style={{ color: "red" }}>{item.status} </td> : <td style={{ color: "green" }}>{item.status}</td>}
                                                <td>
                                                    <button className='update-btn'><Link to={"/update/" + item.id}>Update</Link></button>
                                                </td>
                                                <td onClick={()=> setCurrentImage(item.image)}><img src={`https://server.archanatusharpatil.in/uploads/${item.image}`} alt="" width="100px" height="100px" /></td>
                                                <td>{item.remark}</td>
                                            </tr>
                                        </>
                                    )

                                })
                                :
                                <h1>Loading...</h1>
                        }
                    </tbody>
                </table>
            </div>
            <div className={currentimage ? "popup-image" : "popup"}>
                <div className={currentimage ? 'icon' : "icon-disable"} onClick={() => setCurrentImage(false)}>
                    <FontAwesomeIcon icon={faTimes} size="4x" />
                </div>
                <img src={`https://server.archanatusharpatil.in/uploads/${currentimage}`} alt="" />
                {/* <p className='image-desc'>{currentimage.}</p> */}
            </div>
        </>
    )
}

export default ComplaintList